import {useQuery} from 'react-query';
import teamQuery from './teamQuery';
import teamKeys from './queryKeys';

function useFetchTeamTypes() {
	async function queryFn() {
		const {items} = await teamQuery('teamTypes', {
			fields: ['id', 'name'],
			orderby: 'rank ASC',
		});

		return items;
	}

	const {
		data = [],
		isError,
		isLoading,
	} = useQuery(teamKeys.teamTypes, queryFn, {
		staleTime: 5 * 60 * 1000,
	});

	return {
		items: data,
		isError,
		isLoading,
	};
}

export default useFetchTeamTypes;
